export default [
  {
    content: "용접 부위에 부식, 핀홀 및 크랙이 없고 외관 상태는 양호한가?",
    isChecked: "",
  },
  {
    content: "배관 플랜지, 맨홀 및 밸브 말단 부위에서 누출이 없고 누설된 흔적도 없이 깨끗한가?",
    isChecked: "",
  },
  {
    content: "설계온도 및 압력이 표시된 명판(Name plate)이 부착되어 있는가?",
    isChecked: "",
  },
  {
    content: "교반기 모터 고정 및 전선 연결 상태는 양호하며, 회전 방향 및 속도가 정확한가?",
    isChecked: "",
  },
  {
    content: "작업장 내 폭발 위험장소를 구분하여 관리하고 있으며, 위험장소에는 방폭 전기기계·기구를 설치하였는가?",
    isChecked: "",
  },
  {
    content: "온도계, 압력계, 유랑계 등 계측장치가 설치되어 있고, 파손 또는 고장 없이 정상 기능을 유지하고 있는가?",
    isChecked: "",
  },
  {
    content: "이상 상태를 신속히 알기 위한 자동경보장치가 설치되어 있는가?",
    isChecked: "",
  },
  {
    content: "조업 중 반응기 내부 폭발범위 형성 방지를 위해 질소 등 불활성가스 공급 설비가 설치되어 있는가?",
    isChecked: "",
  },
  {
    content: "비상시 원료의 긴급차단, 제품 등 내용물 방출, 냉각수 투입 장치가 구비되어 있는가?",
    isChecked: "",
  },
  {
    content: "반응기 동체에 안전밸브 또는 파열판이 설치되어 있고, 그 작동압력은 반응기 설계압력 이하로 설정되어 있는가?",
    isChecked: "",
  },
  {
    content: "안전밸브 입구 배관에 파열판이 직렬로 설치된 경우, 안전밸브와 파열판 사이에 압력계가 설치되어 있는가?",
    isChecked: "",
  },
  {
    content: "안전밸브 또는 파열판 입구 배관에 차단밸브는 없는가?",
    isChecked: "",
  },
  {
    content: "안전밸브 또는 파열판 출구 배관을 포집 또는 처리 설비로 연결하여 배출물을 안전하게 처리하는가?",
    isChecked: "",
  },
  {
    content: "작업자 제전복·제전화·제전장갑 착용, 반응기 주변 도전성(금속재) 바닥 접지 및 본딩 등 정전기 방지조치를 하고 있는가?",
    isChecked: "",
  },
  {
    content: "원료, 반응개시제, 촉매 등의 투입량·순서, 반응시간, 교반속도 등이 명시된 작업표준을 작성하여 숙지하고 있는가?",
    isChecked: "",
  },
  {
    content: "비상정지 등 운전 중 비상시 조치요령을 숙지하고 있는가?",
    isChecked: "",
  },
  {
    content: "반응기 세척작업 전, 내부 압력을 대기압으로 낮추고 온도도 상온으로 낮추어 내용물을 안전한 장소로 배출하는가?",
    isChecked: "",
  },
  {
    content: "밸브를 통해 물질이 누출될 수 있으므로 세척작업 전 밸브 이중 잠금 또는 맹판을 설치하여 유체를 차단하는가?",
    isChecked: "",
  },
  {
    content: "세척작업을 할 때 가연성 가스 농도측정기로 인화성 가스농도를 수시로 확인하는가?",
    isChecked: "",
  },
  {
    content: "세척작업을 끝낼 때까지 반응기 부근에 점화원이 될 수 있는 설비를 두지 않고, 작업구역 내 화기작업 등 다른 작업을 수행하지 않는가?",
    isChecked: "",
  },
  {
    content: "세척 후에 반응기 내부를 점검할 때에는 폭발 위험장소에서 사용 가능한 방폭 성능의 전등을 사용하거나, 용기안으로 불빛을 반사하는 거울을 달아 용기 내부를 점검하는가?",
    isChecked: "",
  },
];
